import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";

const LocationPrefrences = ({setLocationPrefrencesIndication}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const parmas = useParams();
  const getListDataByid = async () => {
    setIsLoading(true);
    
    // Dummy data to replace API call
    const dummyData = {
      addressL1: "123 Main Street",
      addressL2: "Apartment 4B",
      landmark: "Near City Mall",
      pincode: "110001",
      state: "Delhi",
      city: "New Delhi",
      lat: "28.6139",
      long: "77.2090"
    };
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyData);
      setCurrentPage(1);
      setPerPage(20);
      if(dummyData){
        setLocationPrefrencesIndication(true);
      } else {
        setLocationPrefrencesIndication(false);
      }
    }, 1000);
  };

  useEffect(() => {
    if (parmas.mid != "") {
      getListDataByid();
    }
  }, []);
  console.log(dataList, "dataListlocation");

  const openMap = (latitude, longitude) => {
    const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(mapUrl, "_blank");
  };
    const handleDownload = (url) => {
    const newWindow = window.open(url, '_blank');
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("Popup blocked. Please enable popups and try again.");
    }
  };
  return (
    <div>
      <div style={{ overflowX: "auto" }}>
        <Table hover>
          <thead>
            <tr style={{ background: "#F6F9FC" }}>
              <th id="tableheding">S.NO</th>
              <th id="tableheding">Address Line 1</th>
              <th id="tableheding">Address Line 2</th>
              <th id="tableheding">Landmark</th>
              <th id="tableheding">Pin Code</th>
              <th id="tableheding"> State</th>
              <th id="tableheding">City</th>
              <th id="tableheding">Google Location</th>
              {/* <th>Action</th> */}
            </tr>
          </thead>
          {!isLoading &&  dataList && (
            <tbody>
              {dataList ? (
                <tr style={{ cursor: "pointer" }}>
                  <td id="tabledata">1</td>
                  <td id="tabledata">{dataList?.addressL1 || "-"}</td>
                  <td id="tabledata">{dataList?.addressL2 || "-"}</td>
                  <td id="tabledata">{dataList?.landmark || "-"}</td>
                  <td id="tabledata">{dataList?.pincode || "-"}</td>
                  <td id="tabledata">{dataList?.state || "-"}</td>
                  <td id="tabledata">{dataList?.city || "-"}</td>
                  <td id="tabledata"  onClick={() => openMap(dataList.lat, dataList.long)}>
                  <i className="fa-solid fa-location-dot"></i>
                  </td>
               
                </tr>
              ) : (
                <tr style={{ textAlign: "center" }}>
                  <td colSpan="6" style={{ verticalAlign: "middle" }}>
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </Table>
      </div>
      <br />
    </div>
  );
};

export default LocationPrefrences;
